import React, { FC, useEffect } from 'react';
import { RootState, AppDispatch } from '../store';
import { useSelector, useDispatch } from 'react-redux';
import { DeviceType, Orientation, Platform, WriteDirection, Lightbox } from 'sofa-reborn-react';
import ConfirmCushions from '../components/ConfirmCushions';
import { PromptButtonTypeEnum } from '@inter-ikea-kompis/component-prompt';
import { setAppView, setCurrentLightbox } from '../store/application/actions';
import { addCushions, resetCameraRotation, selectSceneItem } from '../store/scene/actions';
import {
	setShowFunctionSleep,
	setShowFunctionStorage,
	setShowFunctions,
} from '../store/actionButtons/actions';
import { screenshotPending, setScreenshotSpinner } from '../store/checkout/actions';

const ConfirmCushionsContainer: FC = () => {
	const deviceType = useSelector<RootState, DeviceType>((state) => state.deviceInfo.deviceType);
	const orientation = useSelector<RootState, Orientation>((state) => state.deviceInfo.orientation);
	const platform = useSelector<RootState, Platform>((state) => state.deviceInfo.platform);
	const writeDirection = useSelector<RootState, WriteDirection>(
		(state) => state.localization.writeDirection
	);
	const showFunctionSleep = useSelector<RootState, boolean>(
		(state) => state.actionButtons.showFunctionSleep as boolean
	);
	const showFunctionStorage = useSelector<RootState, boolean>(
		(state) => state.actionButtons.showFunctionStorage as boolean
	);
	const showFunctions = useSelector<RootState, boolean>(
		(state) => state.actionButtons.showFunctions as boolean
	);

	const currentLightbox = useSelector<RootState, Lightbox>(
		(state) => state.application.currentLightbox
	);

	const dispatch = useDispatch<AppDispatch>();

	const onAddCushions = (): void => {
		dispatch(addCushions(true));
		dispatch(setCurrentLightbox('none'));
	};

	const onProceedToSummaryPage = (dispatch: AppDispatch): void => {
		if (showFunctionSleep) {
			dispatch(setShowFunctionSleep(false, false));
		}
		if (showFunctionStorage) {
			dispatch(setShowFunctionStorage(false, false));
		}
		if (showFunctions) {
			dispatch(setShowFunctions(false));
		}
		dispatch(resetCameraRotation(true));
		dispatch(setScreenshotSpinner(true));
		setTimeout(() => {
			// dispatching delayed to increase the chances of babylon getting a frame ready...
			dispatch(screenshotPending());
		}, 300);
		dispatch(setCurrentLightbox('none'));
		dispatch(setAppView('summary-page'));
	};

	useEffect(() => {
		dispatch(selectSceneItem(null));

		return (): void => {
			return;
		};
	}, []);

	return (
		<ConfirmCushions
			deviceType={deviceType}
			orientation={orientation}
			writeDirection={writeDirection}
			platform={platform}
			showPrompt={currentLightbox === 'confirm-cushion'}
			onClick={(event: CustomEvent) => {
				if (event.detail.type === PromptButtonTypeEnum.primaryButton) {
					onAddCushions();
				} else {
					onProceedToSummaryPage(dispatch);
				}
			}}
		></ConfirmCushions>
	);
};

export default ConfirmCushionsContainer;
